import * as z from "zod";
export const ToolAuditEntrySchema = z.object({
  id: z.string(),
  name: z.string(),
  label: z.string(),
  startedAt: z.string(),
  completedAt: z.string().optional(),
  durationMs: z.number().nonnegative().optional(),
  outcome: z.enum(["running", "succeeded", "error", "paused", "unknown"]),
  error: z.string().optional(),
});
export const ToolAuditOutputSchema = z.object({
  entries: z.array(ToolAuditEntrySchema),
  truncated: z.boolean(),
});
export type ToolAuditEntry = z.infer<typeof ToolAuditEntrySchema>;
export type ToolAuditOutput = z.infer<typeof ToolAuditOutputSchema>;
